import { D3Selection } from "svg/draw/draw-calendar";
import { CalendarSizeDimensions } from "svg/constants";
import { SpiralItem } from "burde";

const drawCoverSpiral = (
    svg: D3Selection,
    spiral: SpiralItem | null,
    positionSpiralToRight: boolean,
    numberOfSpirals: number,
    calendarDimensions: CalendarSizeDimensions,
) => {
    const spiralHeightGap: number =
        (calendarDimensions.contentHeightWithoutBleeds -
            numberOfSpirals * calendarDimensions.spiralHeight) /
        (numberOfSpirals + 1);

    var spiralStartPos: number =
        calendarDimensions.presentationEmptySpaceHeight;

    let xPos = calendarDimensions.presentationEmptySpaceWidth;

    if (positionSpiralToRight) {
        xPos += calendarDimensions.contentWidthWithoutBleeds;
    }

    if (!spiral) return;

    const spiralImage = spiral.image.replace("#", "single");

    for (let i = 0; i < numberOfSpirals; i++) {
        let group = svg
            .append("g")
            .attr(
                "transform",
                `translate(${xPos},${
                    spiralStartPos +
                    spiralHeightGap +
                    calendarDimensions.spiralHeight / 2
                }) rotate(${positionSpiralToRight ? 180 : 0})`,
            )

            .attr("class", "spiral");
        group
            .append("svg:image")
            .attr("width", calendarDimensions.spiralWidth)
            .attr("height", calendarDimensions.spiralHeight)
            .attr("xlink:href", `/images/${spiralImage}`)
            .attr(
                "transform",
                `translate(${calendarDimensions.spiralTranslateX}, ${calendarDimensions.spiralTranslateY}) `,
            );

        spiralStartPos += calendarDimensions.spiralHeight + spiralHeightGap;
    }
};

export { drawCoverSpiral };
